import { Product, ProductTable } from "@/types/system-setting/product";
import { apiSlice } from "@/redux/apiSlice";

interface ProductQuery {
  query: string;
  org_id: number;
}

export const Products = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getAllProducts: builder.query<ProductTable, ProductQuery>({
        query: (searchCretiria) => ({
          url: `/products?org_id=${searchCretiria.org_id}${searchCretiria.query?.length > 0 ? "&" + searchCretiria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Product", "Transaction"],
      }),
      addProduct: builder.mutation<Product, Product>({
        query: (productData) => ({
          url: `/products`,
          method: "POST",
          body: productData,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["Product", "Transaction"],
      }),
      updateProduct: builder.mutation<Product, Product>({
        query: (productData) => ({
          url: `/products/${productData.id}`,
          method: "PUT",
          body: productData,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["Product"],
      }),
      deleteProduct: builder.mutation<Product, {product_id: number, org_id: number}>({
        query: ({product_id, org_id}) => ({
          url: `/products/${product_id}?org_id=${org_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Product"],
      }),
      getProductById: builder.query<Product, {product_id: number, org_id: number}>({
        query: ({product_id, org_id}) => ({
          url: `/products/${product_id}?org_id=${org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Product", "Transaction"],
      }),
    };
  },
});

export const {
  useGetProductByIdQuery,
  useGetAllProductsQuery,
  useAddProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = Products;
